import {
  Cog6ToothIcon,
  HomeIcon,
  ShoppingBagIcon,
  Squares2X2Icon,
  QueueListIcon,
} from "@heroicons/react/24/outline";
import { isReadOnlyUser } from "./utility";

export default function routes(pathname, user_type, user_id = null) {
  var title;
  var routes;

  const isCFIA = user_type === 4;
  // determine if the current user is read-only (utility handles the logic)
  const isReadOnly = isReadOnlyUser(user_type, user_id);

  routes = [
    {
      name: "Dashboard",
      href: "/dashboard",
      icon: HomeIcon,
      current: false,
      showInMenu: !isCFIA,
    },

    {
      name: "Products",
      href: "/products",
      icon: ShoppingBagIcon,
      current: false,
      showInMenu: !isCFIA,
    },
 
    {
      name: "Categories",
      href: "/categories",
      icon: Squares2X2Icon,
      current: false,
      showInMenu: !isCFIA,
    },
    {
      name: "Subcategories",
      href: "/subcategories",
      icon: QueueListIcon,
      current: false,
      showInMenu: !isCFIA,
    },
    {
      name: "Setup",
      icon: Cog6ToothIcon,
      current: false,
      showInMenu: !isCFIA,
      open: false,
      children: [
      
     
        { name: "Users", href: "/users", current: false },
 
      ],
    },
  ];

  // Remove the Setup section entirely for read-only users
  if (isReadOnly) {
    routes = routes.filter((route) => route.name !== "Setup");
  }

  routes.forEach((route) => {
    route.open = false;
    if (route.children) {
      route.children.forEach((child) => {
        child.current = false;
        if (child.href === pathname) {
          route.open = true;
          child.current = true;

          title = child.name;
        }
      });
    } else if (route.href === pathname) {
      route.current = true;

      title = route.name;
    }
  });

  var returnArray = {
    routes: routes.filter((route) => route.showInMenu),

    title: title,
  };

  return returnArray;
}
